import { render } from "./WidgetContainer.vue?vue&type=template&id=5204ab37&scoped=true"
import script from "./WidgetContainer.vue?vue&type=script&lang=js"
export * from "./WidgetContainer.vue?vue&type=script&lang=js"

import "./WidgetContainer.vue?vue&type=style&index=0&id=5204ab37&scoped=true&lang=css"
import "./WidgetContainer.vue?vue&type=style&index=1&id=5204ab37&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5204ab37"]])

export default __exports__